

<div class="vh-100">
  <div id="wrapper" class="toggled vh-100">
      <kp-left-nav></kp-left-nav>
      <div id="content-wrapper" class="page-content-wrapper me-3 h-100 mb-4">
          <kp-content></kp-content>
          <router-outlet />
      </div>
  </div>
</div>
